// Shared TextField / PasswordInput styles for Auth screens (300 x 56)
export const authFieldSx = {
  marginBottom: 2,
  width: 300,
  maxWidth: 300,
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    width: 300,
    maxWidth: 300,
    height: 56,
    minHeight: 56,
    boxSizing: 'border-box',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.25)'
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.25)'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.25)'
    },
    '& input': {
      color: 'white !important',
      height: 56,
      boxSizing: 'border-box',
      padding: '0 14px',
      '&:-webkit-autofill': {
        WebkitTextFillColor: 'white !important',
        WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
        boxShadow: '0 0 0 1000px transparent inset !important',
        transition: 'background-color 5000s ease-in-out 0s'
      },
      '&:-webkit-autofill:hover': {
        WebkitTextFillColor: 'white !important',
        WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
        boxShadow: '0 0 0 1000px transparent inset !important'
      },
      '&:-webkit-autofill:focus': {
        WebkitTextFillColor: 'white !important',
        WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
        boxShadow: '0 0 0 1000px transparent inset !important'
      }
    },
    color: 'white'
  },
  '& .MuiInputLabel-root': {
    color: 'white'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white'
  },
  '& .MuiFormHelperText-root': {
    color: 'rgba(255, 255, 255, 0.7)'
  }
}
